import { httpClient, HttpMethod } from './http-client';
import {
  ImportResourceResponse,
  ImportSession,
  ImportSessionData,
  ImportSessionQueryData,
  ImportSessionResource,
  ImportSessionResourceResponse,
  ImportSessionStatusCode
} from '../@types';

export const createImportSession = (importSessionDataObject: ImportSessionData): Promise<ImportSession> => {
  return httpClient<ImportSession>('/importSessions', HttpMethod.Post, importSessionDataObject);
};

export const getImportSessionById = (sessionId: number, resourceType: string): Promise<ImportSession> => {
  return httpClient<ImportSession>(`/importSessions/${resourceType}/${sessionId}`, HttpMethod.Get);
};

export const getImportedResourceBySessionId = (sessionId: number, resourceType: string, queryData: ImportSessionQueryData): Promise<ImportSessionResourceResponse> => {
  let url = `/importSessions/${resourceType}/${sessionId}/importedResources?page=${queryData.page + 1}&limit=${queryData.limit}&showErrorRecords=${queryData.showErrorRecords}&showCreateableRecords=${queryData.showCreateableRecords}`;
  if (queryData?.showUpdateableRecords !== undefined) {
    url += `&showUpdateableRecords=${queryData.showUpdateableRecords}`;
  }
  return httpClient<ImportSessionResourceResponse>(url, HttpMethod.Get);
};

export const uploadResource = (resourceType: string, file: FormData): Promise<ImportResourceResponse> => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return httpClient<ImportResourceResponse>(`/uploadedResources/uploadFile/${resourceType}`, HttpMethod.Post, file, headers);
};

export const updateImportSession = (id: number, importSessionStatusCode: ImportSessionStatusCode, resourceType: string): Promise<ImportSession> => {
  return httpClient<ImportSession>(`/importSessions/${resourceType}/${id}`, HttpMethod.Put, importSessionStatusCode);
};

export const getImportSessionSummary = (sessionId: number, resourceType: string): Promise<ImportSessionResource[]> => {
  return httpClient<ImportSessionResource[]>(`/importSessions/${resourceType}/${sessionId}/summary`, HttpMethod.Get);
};
